import React from 'react';
import { Box, RichText } from '@wegroup/design-system';
import { handleResponseLanguage } from '../../../../../../../i18n';
import useFlowInputComponent from '@flows/src/hooks/useFlowsInputComponent';
import { FlowsQuestion } from '@flows/src/types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}

/**
 * DisplayInputComponent renders HTML content without expecting user input.
 * It displays the description as HTML content on the screen.
 * This is useful for showing informational content, instructions, or static HTML within flows.
 */
const DisplayInputComponent: React.FC<Props> = ({ question }) => {
  // Use the flow input component hook to maintain flow state consistency
  useFlowInputComponent({ question });

  // Get the HTML content from description using the standard language handler
  const htmlContent = handleResponseLanguage(question.description);

  // If no content, render nothing
  if (!htmlContent) {
    return null;
  }

  return (
    <Box width="100%" p={4}>
      <RichText value={htmlContent} />
    </Box>
  );
};

export default DisplayInputComponent;
